import { baseTheme } from "@app/theme";
import { Box, ThemeProvider, Typography } from "@mui/material";

export const MsalErrorScreen = () => {
  return (
    <ThemeProvider theme={baseTheme}>
      <Box
        sx={{
          height: "99vh",
          overflowX: "auto",
          borderRadius: "0px",
          backgroundColor: "primary.light",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "45px",
          gap: "20px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "primary.light",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: "secondary.contrastText",
            }}
          >
            Oh no!
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: "primary.light",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "7px",
          }}
        >
          <Typography
            sx={{
              color: "secondary.contrastText",
            }}
          >
            Dolphin was unable to let you in.
          </Typography>
          <Typography
            sx={{
              color: "secondary.contrastText",
            }}
          >
            If you feel like this was a mistake, contact the system
            administrator.
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MsalErrorScreen;
